// LeftSidebar.js
import React from "react";

import {
  // ✈️ FLIGHT / PLANNING
  PLaneTakeoff,
  Map,
  MapPinned,
  Navigation,

  // 🌦 WEATHER / HAZARDS
  Radar,
  CloudLightning,
  AlertTriangle,
  CloudDrizzle,
  CloudSun,
  MessageSquareWarning,

  // 🧭 NAVIGATION / OPERATIONAL
  TowerControl,
  RadioTower,
  LocateFixed,
  Pentagon,
  ShieldAlert,
  PlaneTakeoff

} from "lucide-react";

import "./LeftSidebar.css";

export default function LeftSidebar({

  onSelect,

  onToggleRadar,
  onToggleSigmets,
  onToggleAirmets,
  onToggleAirportConditions,
  onToggleVfrSectionals,
  onToggleIfrLow,
  onToggleIfrHigh,
  onToggleEchoTops,
  onOpenFlightPlan,
  onTogglePirepFilter,
  onToggleAirspaces,

  onToggleTFRs,

  onToggleVors,
  onToggleFixes,

  // 🌦 WEATHER SEARCH
  onToggleWeatherSearch,

  active,

}) {

  const buttons = [

    // =====================================
    // ✈️ FLIGHT / PLANNING
    // =====================================

    {
      id: "flight",
      icon: <PlaneTakeoff size={22} />,
      label: "Flight Input",
      onClick: onOpenFlightPlan
    },

    {
      id: "vfr",
      icon: <Map size={22} />,
      label: "VFR Sectionals",
      onClick: onToggleVfrSectionals
    },

    {
      id: "ifrLow",
      icon: <MapPinned size={22} />,
      label: "IFR Low",
      onClick: onToggleIfrLow
    },

    {
      id: "ifrHigh",
      icon: <Navigation size={22} />,
      label: "IFR High",
      onClick: onToggleIfrHigh
    },


    // =====================================
    // 🌦 WEATHER / HAZARDS
    // =====================================

    {
      id: "radar",
      icon: <Radar size={22} />,
      label: "Radar",
      onClick: onToggleRadar
    },

    {
      id: "echo",
      icon: <CloudLightning size={22} />,
      label: "Echo Tops",
      onClick: onToggleEchoTops
    },

    {
      id: "sigmet",
      icon: <AlertTriangle size={22} />,
      label: "SIGMETs",
      onClick: onToggleSigmets
    },

    {
      id: "airmet",
      icon: <CloudDrizzle size={22} />,
      label: "AIRMETs",
      onClick: onToggleAirmets
    },

    {
      id: "weather",
      icon: <CloudSun size={22} />,
      label: "Weather Search",
      onClick: onToggleWeatherSearch
    },

    {
      id: "pirep",
      icon: <MessageSquareWarning size={22} />,
      label: "PIREP Filter",
      onClick: onTogglePirepFilter
    },


    // =====================================
    // 🧭 NAVIGATION / OPERATIONAL
    // =====================================

    {
      id: "airport",
      icon: <TowerControl size={22} />,
      label: "Airport Conditions",
      onClick: onToggleAirportConditions
    },

    {
      id: "vors",
      icon: <RadioTower size={22} />,
      label: "VORs",
      onClick: onToggleVors
    },

    {
      id: "fixes",
      icon: <LocateFixed size={22} />,
      label: "Fixes",
      onClick: onToggleFixes
    },

    {
      id: "airspaces",
      icon: <Pentagon size={22} />,
      label: "Airspaces",
      onClick: onToggleAirspaces
    },

    {
      id: "tfr",
      icon: <ShieldAlert size={22} />,
      label: "TFRs",
      onClick: onToggleTFRs
    }

  ];

  return (

    <div className="left-sidebar">

      {buttons.map(({
        id,
        icon,
        label,
        onClick
      }, index) => {

        // =====================================
        // VISUAL GROUP SEPARATORS
        //
        // Separator before Radar:
        // Flight/Planning → Weather/Hazards
        //
        // Separator before Airport:
        // Weather/Hazards → Navigation/Ops
        // =====================================

        const showSeparator =
          id === "radar" ||
          id === "airport";

        return (

          <React.Fragment key={id}>

            {showSeparator && (

              <div
                style={{
                  width: "28px",
                  height: "1px",
                  background:
                    "rgba(255,255,255,0.22)",
                  margin: "5px auto"
                }}
              />

            )}

            <button

              className={`
                sidebar-icon
                ${
                  Array.isArray(active) &&
                  active.includes(id)
                    ? "active"
                    : ""
                }
              `}

              title={label}

              onClick={() => {

                // =====================================
                // ✈️ FLIGHT BUTTON
                // =====================================

                if (id === "flight") {

                  onSelect?.("flight");

                  return;
                }

                // =====================================
                // NORMAL BUTTON ACTION
                // =====================================

                onClick?.();

                // =====================================
                // OVERLAY GLOW STATE
                // =====================================

                onSelect?.(id);

              }}

            >

              {icon}

            </button>

          </React.Fragment>

        );

      })}

    </div>

  );
}